













































import { computed, defineComponent } from '@vue/composition-api';

import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';

import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';

const PanelWithDriverInformation = defineComponent({
  components: { CommonPanelWithExpandable },
  props: {
    driver: { default: () => ({ name: '', avatarUrl: '' }) },
    vehicle: {
      default: () => ({
        license: '', licenseProvince: '', model: '', avatarUrl: '',
      }),
    },
    deliveryArea: { default: () => ({ code: 'NA', name: '', distanceType: '' }) },
    width: { default: '36rem' },
    distanceTravelled: { default: 0 },
  },
  setup() {
    const { me } = useAuth();
    const { distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();
    const toDecimalFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return {
      me,
      toDecimalFormat,
      distanceTypeToChipClass,
      translateDistanceType,
    };
  },
});

export default PanelWithDriverInformation;
